import { render, staticRenderFns } from "./Serial.vue?vue&type=template&id=baf76930&scoped=true&"
import script from "./Serial.vue?vue&type=script&lang=js&"
export * from "./Serial.vue?vue&type=script&lang=js&"
import style0 from "./Serial.vue?vue&type=style&index=0&id=baf76930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf76930",
  null
  
)

export default component.exports